import find from 'lodash/find'
import map from 'lodash/map'
import { useRouter } from 'next/router'
import React, { FC, memo } from 'react'

import { AccordionSidePane } from '@Domains/Product/Features/Display/AccordionSidePane/AccordionSidePane'
import { BaseAttribute, Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductDescription.module.scss'

interface ProductDescriptionProps {
  product?: Product
}

export type GeneratedDescription = Record<string, string>

export const ProductDescription: FC<ProductDescriptionProps> = memo(({ product }) => {
  const { t } = useTranslation()
  const { locale = '' } = useRouter()

  if (!product || !product.description) {
    return null
  }

  let descriptionText = product?.description
  const generatedDescriptions = (
    (find(product?.masterVariant?.attributes, ['key', 'descriptionGenerated']) as BaseAttribute)?.value || undefined
  ) as GeneratedDescription
  if (generatedDescriptions !== undefined && generatedDescriptions[locale]) {
    descriptionText = generatedDescriptions[locale]
  }

  const processedDescriptionText = map(
    descriptionText.trim().split('\n'),
    (line, index) => {
      const trimmedData = line.trim()
      return trimmedData.length
        ? <p key={`${index}${line}`}>{trimmedData}</p>
        : null
    },
  )

  return (
    <AccordionSidePane prerender title={t('products:DESCRIPTION')}>

      {processedDescriptionText}

      {product.type === 'piercings' && (
        <p>
          <strong>
            {t('products:PIERCINGS_ONLY_RETURNABLE_IN_UNOPENED_PACKAGING')}
          </strong>
        </p>
      )}

      {
          (product.type === 'socks' || product.type === 'boxers')
            && (
              <p>
                <strong>
                  {t('products:PIERCINGS_ONLY_RETURNABLE_IN_UNOPENED_PACKAGING')}
                </strong>
              </p>
            )
        }

      <div className={styles.productId}>
        {`ID: ${product.id}`}
      </div>
    </AccordionSidePane>
  )
})
